











































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
@Component({
  name: "Template",
})
export default class Template extends Vue {
  public keyword = "";
  activeMenu(value) {
    return this.$router.currentRoute.name === value ? "select" : "";
  }

  resetKeyword() {
    this.keyword = "";
  }

  mounted() {
    let query = this.$router.currentRoute.query;
    this.keyword = query.keyword?.toString();
  }

  @Watch("keyword")
  changeSelected() {
    let { name, params, query } = this.$router.currentRoute;

    query = {
      ...query,
      ...{ keyword: this.keyword },
    };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }
}
